import { css } from '@emotion/react';
import React from 'react';

import { useSpaceMatchingKey, useTheme } from '../theme';

/**
 * This divider offsets itself by the padding of the card so it stretches across the padding.
 */
export const CardFlushDivider = () => {
  const space = useSpaceMatchingKey('s');
  const { colors, keylines, componentProperties } = useTheme();
  return (
    <div
      css={css`
        border-bottom: ${componentProperties.cardFlushDivider?.border ||
        keylines?.border ||
        `1px solid ${colors.primary300}`};
        margin-inline-start: ${componentProperties.cardFlushDivider
          ?.marginInlineStart || `-${space}`};
        margin-inline-end: ${componentProperties.cardFlushDivider
          ?.marginInlineEnd || `-${space}`};
      `}
    />
  );
};
